// ----------------------------------
// ------------ GENERAL -------------
// ----------------------------------


// Set a statut to the device Maïa false="off" true="on"
let powerStatut = false;
let playStatut = false;

//let serverSounds = 'https://www.dawtemplatesmaster.com/maia-interactive/sounds/';
let serverSounds = 'https://maiasaura.ovh/Maia-interactive/FR/sounds/';

let longPress = false;
const imgTrackMaia = document.querySelector('.current-track-img');


// ----------------------------------------
// ------------ MUSIC TO PLAY -------------
//-----------------------------------------

// Index folder and file to play
let audioFileIndex = 0;
let folderFileIndex = 0;

// Inside folder

const comptines = [
    '1 - EXTRAIT Dans sa maison un grand cerf.mp3',
    '2 - EXTRAIT La fourmi.mp3',
    '3 - EXTRAIT Dans la forêt lointaine.mp3',
    '4 - EXTRAIT Un éléphant qui se balançait.mp3',
    '5 - EXTRAIT Ah les Crocodiles.mp3',
    '6 - EXTRAIT Promenons nous dans les bois.mp3',
    '7 - EXTRAIT L\'araignée Gipsy.mp3',
    '8 - EXTRAIT A La volette.mp3',
    '9 - EXTRAIT Au Feu Les Pompiers.mp3',
    '10 - EXTRAIT Les petits poissons.mp3',
    '11 - EXTRAIT La semaine des canards.mp3',
    '12 - EXTRAIT Nagawicka.mp3',
    '13 - EXTRAIT Ah vous dirai je maman.mp3',
    '14 - EXTRAIT Petit escargot.mp3',
    '15 - EXTRAIT Pirouette cacahuète.mp3',
    '16 - EXTRAIT Pomme de reinette et pomme d\'api.mp3',
    '17 - EXTRAIT Tourne petit moulin.mp3',
    '18 - EXTRAIT Il était un petit navire.mp3',
    '19 - EXTRAIT Lundi matin.mp3',
    '20 - EXTRAIT Une souris verte.mp3',
    '21 - EXTRAIT Cadet Roussel.mp3',
    '22 - EXTRAIT A la pêche aux moules.mp3',
    '23 - EXTRAIT Les petites marionnettes.mp3',
    '24 - EXTRAIT Dans la ferme de maturin.mp3',
    '25 - EXTRAIT A la claire fontaine.mp3',
   
]


const histoires = [
    '1 - EXTRAIT Le Lion et Le Rat.mp3',
    '2 - EXTRAIT Le Corbeau et Le Renard.mp3',
    '3 - EXTRAIT La Cigale et La Fourmi.mp3',
    '4 - EXTRAIT Le Renard et La Cigogne.mp3',
    '5 - EXTRAIT Le Lievre et La Tortue.mp3',
    '6 - EXTRAIT Les 7 Cheveraux.mp3',
    '7 - EXTRAIT Le Vilain Petit Canard.mp3',
    '8 - EXTRAIT La Chèvre de Mr Seguin.mp3',
    '9 - EXTRAIT Cendrillon.mp3',
    '10 - EXTRAIT Le Petit Chaperon Rouge.mp3',
    
  

]

const berceuses = [
    '1 - EXTRAIT Bonsoir.mp3',
    '2 - EXTRAIT Quand tout se tait.mp3',
    '3 - EXTRAIT A la Nanita.mp3',
    '4 - EXTRAIT Berceuse cosaque.mp3',
    '5 - EXTRAIT Dodo ti pittit.mp3',
    '6 - Extrait Berceuse la chaumiére.mp3',
    '7 - Extrait Neni Neni.mp3',
    '8 - Extrait Berceuse Le bruit de la pluie.mp3' , 
    '9 - Extrait O Seya.mp3',
    '10 - Extrait Duerme Pequeno.mp3',
    '11 - EXTRAIT Ninna na.mp3',
    '12 - Extrait Ma Ajmala Assama.mp3',
    '13 - Extrait Colas mon petit frère.mp3',
    '14 - Extrait Acalanto Para Helena.mp3',
    '15 - Extrait Dandini.mp3',

  
]

const mp3_parents = [
    '1 - Mamie - Pierre et le loup.mp3',
    '2 - Le Roi Lion.mp3',
    '3 - Berceuse Baby-Jazz.mp3',
]

// All music folders
const musicFolder = [
    "Comptines",
    "Histoires",
    "Berceuses",
    "MP3 Famille",
]

const messageInfo_fr = {
    message1: 'Vous venez de passer à la piste suivante. Vous écoutez actuellement : ',
    message2: 'Vous devez d\'abord allumer Maïa en appuyant 3 secondes le bouton "power" pour changer le dossier d\'écoute.',
    message3: 'Vous venez de passer au dossier suivant.',
    message4: 'Grâce au bouton "play" votre musique se lance. Si vous appuyez une nouvelle fois la musique se mettra en pause.',
    message5: 'Votre musique est maintenant en pause. Appuyez une nouvelle fois sur le bouton "play" pour la relancer.',
    message6: 'Vous devez d\'abord allumer Maïa en appuyant 3 secondes le bouton "power" pour pouvoir écouter de la musique.',
    message7: 'Volume au maximum',
    message8: 'Volume augmenté',
    message9: 'Vous devez d\'abord allumer Maïa avec le bouton "power" pour changer la piste d\'écoute.',
    message10: 'Volume au minimum',
    message11: 'Volume diminué',
    message12: 'Vous venez de passer à la piste précedente. Vous écoutez actuellement : '

}

const messageTooltips_fr = {
    message1: 'Maïa est allumée',
    desc1_1: 'Appuyer 1 fois pour changer de répertoire',
    desc1_2: 'Appuyer 3 sec pour allumer Maïa',
    desc2_1: 'Appuyer 1 fois pour le morceau suivant',
    desc2_2: 'Appuyer 3 sec pour augmenter le volume',
    desc3_1: 'Appuyer 1 fois pour le morceau précedent',
    desc3_2: 'Appuyer 3 sec pour diminuer le volume',
    desc4_1: 'Play / Pause',
    desc5_1: 'Jouer avec maia en appuyant sur Play'


}
// What is the file to play

let whatFolder = musicFolder[folderFileIndex];
let fileToPlay = "";
let fileToPlayImage = fileToPlay.replace('.mp3', '.jpeg');
const whatFile = () => {

    // if (whatFolder === "Berceuses") {
    if (whatFolder == musicFolder[0]) {
        fileToPlay = comptines[audioFileIndex];
    }
    if (whatFolder == musicFolder[1]) {
        fileToPlay = histoires[audioFileIndex];
    }
    if (whatFolder === musicFolder[2]) {
        fileToPlay = berceuses[audioFileIndex];
    }
    if (whatFolder === musicFolder[3]) {
        fileToPlay = mp3_parents[audioFileIndex];
    }
    fileToPlayImage = serverSounds + whatFolder + '/' + fileToPlay.replace('.mp3', '.jpeg');
    return fileToPlay;
};


// API web Audio for up and down the volume

let audioContext = new AudioContext();
let music = new Audio(serverSounds + whatFolder + '/' + whatFile());
let analyser = audioContext.createAnalyser();
let source = audioContext.createMediaElementSource(music);
source.connect(analyser);
analyser.connect(audioContext.destination);


// Give the length of the folder
const whatFolderLength = () => {

    let folderLength = 0;
    if (whatFolder == musicFolder[0]) {
        folderLength = comptines.length;
    }
    if (whatFolder === musicFolder[1]) {
        folderLength = histoires.length;
    }
    if (whatFolder === musicFolder[2]) {
        folderLength = berceuses.length;
    }
    if (whatFolder === musicFolder[3]) {
        folderLength = mp3_parents.length;
    }
    return folderLength;
};

// Change playStatut when the music is ended then close animation div
const musicEnded = () => {
    // music.addEventListener('ended', () => {
    audioFileIndex++;

    if (audioFileIndex >= whatFolderLength()) {
        audioFileIndex = 0;
    }
    // music = new Audio(serverSounds + whatFolder + '/' + whatFile());
    music.src = serverSounds + whatFolder + '/' + whatFile();
    music.play();
    // document.querySelector('.current-track').textContent = fileToPlay;
    //changement image
    imgTrackMaia.src = fileToPlayImage;

    // Add a message
    messageInfo(messageInfo_fr.message1 + whatFile())

    // });
}



//--------- Musical Notes ------------

const musicalNotes = document.getElementById('notes');

const toggleShowNotes = () => {
    if (playStatut === true) {
        musicalNotes.style.display = "block";
    }
    if (playStatut === false) {
        musicalNotes.style.display = "none";
    }
}



// Get all the area elements
const areas = document.getElementsByTagName('area');

// Attach an event listener to each area element
for (let i = 0; i < areas.length; i++) {
    areas[i].addEventListener('mouseover', () => {
        // Get the corresponding info-box element based on the id
        const infoBox = document.getElementById(`desc${i + 1}`);
        // Show the info-box
        infoBox.style.display = 'flex';
    });

    areas[i].addEventListener('mouseout', (event) => {
        // Get the corresponding info-box element based on the id
        const infoBox = document.getElementById(`desc${i + 1}`);
        // Hide the info-box
        infoBox.style.display = 'none';
    });
}

// ----------------------------------
// --------- POWER BUTTON -----------
// ----------------------------------
const powerArea = document.querySelector('area[alt="power"]');
// const item5 = document.getElementById('desc5');
const maiaMessage = document.querySelector('.maia-message');
const maiaState = document.querySelector('.maia-state')
const maiaPlayingBox = document.querySelector('.playing-box')


const compteur = document.getElementById('compteur');
const etat = document.getElementById('etat');
const rowEtat = document.getElementById('row-etat');
const rowEtatPlusButton = document.querySelector('#desc2 #row-etat')
const rowEtatMinusButton = document.querySelector('#desc3 #row-etat')
let intervalID;



const buttonPowerMouseDown = function (event) {
    // tooltip mobile helper hide once click play
    document.querySelector('.play-button-tooltip-mobile').style.display = 'none';
    //display instructions on mobile by adding class visible
    //document.querySelector('.tooltip-mobile').classList.add('visible');

    let i = 0;
    if (i = 0) {
        // rowEtat.style.display ="flex";
        // compteur.innerHTML = '0s'
    };


    intervalID = setInterval(() => {
        i++;
        if (i > 0) {
            rowEtat.style.display = "flex";
        };
        //Seconds before start Maia
        if (i == 3) {
            clearInterval(intervalID);
            longPress = true
            //toggle powerStatut
            powerStatut = !powerStatut;
            compteur.innerHTML = i + 's';
            if (powerStatut === true) {
                powerMaia()

            } else if (powerStatut === false) {
                offMaia()
            }

        } else {
            compteur.innerHTML = i + 's';
        }
    }, 1000);

};


const buttonPowerMouseUp = function (event) {
    clearInterval(intervalID);
    compteur.innerHTML = '';
    rowEtat.style.display = "none";
    // compteur.style.visibility ="hidden";
    //TODO switch le message du bouton power une fois allumer
    // let maiaTooltipPower = '<span>Appuyer 1 seconde pour changer de dossier</span><br><hr><span>Appuyer 3 secondes pour eteindre Maïa</span>';
    // document.querySelector('.maia-me.info-1').innerHTML = maiaTooltipPower;
    // setTimeout(() => {
    //     powerArea.addEventListener("click", changeFolder);
    // }, 1000);
    if (longPress == false) {
        changeFolder(event);
    }
    //reset longPress
    longPress = false;
};



powerArea.addEventListener("mousedown", buttonPowerMouseDown);
powerArea.addEventListener("mouseup", buttonPowerMouseUp);
powerArea.addEventListener('mouseleave', () => {
    clearInterval(intervalID);
    compteur.innerHTML = '';
    // compteur.style.visibility ="hidden";
    rowEtat.style.display = "none";
});



// If power is clicked 3sec when the device is off, launch power sound & message
const powerMaia = () => {
    powerStatut = true;
    //Display green message power ON on top left
    // maiaMessage.style.display = powerStatut ? "flex" : "none";
    // maiaPlayingBox.style.display = powerStatut ? "flex" : "none";
    document.querySelector(".info-panel-maia1").style.display = powerStatut ? "flex" : "none";

    //rempli les champs de dossier et music
    document.querySelector('.current-folder').textContent = '/' + whatFolder;
    // document.querySelector('.current-track').textContent = fileToPlay;
    messageMaiaInfoContainer.style.display = "none";
    const music = new Audio(serverSounds + 'switch-on.mp3');
    music.play()
    // toggle bandeau green or red
    maiaState.classList.toggle("maia-me-green");
    maiaState.classList.remove("maia-me-red");
    // tootltip toggle
    imgTrackMaia.src = fileToPlayImage;
    document.querySelector('.maia-state-text').textContent = 'Maïa est allumée';
    document.querySelector('.maia-power-text-l1').textContent = 'Appuyez 3 secondes pour eteindre Maïa';
    //autostart 1st track
    //execute function when music opener finish to play
    music.onended = function () {
        playMaia();
    }

};

// If power is clicked 3sec when the device is on, launch off sound & message
const offMaia = () => {

    maiaState.classList.toggle("maia-me-red");
    maiaState.classList.remove("maia-me-green");
    // remove class "maia-me-green" de maiaState
    document.querySelector('.maia-state-text').textContent = 'Maïa est éteinte'
    // document.querySelector('.maia-me.info-1').children[0].textContent = 'Appuyer 3 secondes pour allumer Maïa'
    document.querySelector('.maia-power-text-l1').textContent = 'Appuyez 3 secondes pour allumer Maïa'
    // If a music is played stop it
    music.pause();
    music.currentTime = 0;
    playStatut = false;
    toggleShowNotes();


    // Sound off
    const audio = new Audio(serverSounds + 'switch-off.mp3');
    audio.play();



};

// =======================================================
// ========== Function changeFolder ======================
// =======================================================
// If power is clicked when the device is on, change music files folder
const changeFolder = (e) => {
    // console.log(e);

    // If the device is off text alert
    if (powerStatut == false) {
        messageInfo(messageInfo_fr.message2)
    };
    // If the device is On
    if (powerStatut == true) {
        // If a music is already played
        music.pause();
        music.currentTime = 0;
        // Change to next folder then play the first file
        folderFileIndex++;
        audioFileIndex = 0;
        if (folderFileIndex >= musicFolder.length) {
            folderFileIndex = 0;
        }
        whatFolder = musicFolder[folderFileIndex];
        // music = new Audio(serverSounds + whatFolder + '/' + whatFile());
        music.src = serverSounds + whatFolder + '/' + whatFile();
        // music.load();

        // si deja en cours de lecture
        // if (playStatut == true)

        //Lecture automatique au changement du dossiers
        music.play();
        playStatut = true;

        document.querySelector('.current-folder').textContent = '/' + whatFolder;

        // document.querySelector('.current-track').textContent = fileToPlay;
        //changement image
        imgTrackMaia.src = fileToPlayImage;
        //anime
        animeIcons(e);
        toggleShowNotes();

        // musicEnded();

        messageInfo(messageInfo_fr.message3);
    };
};


// ----------------------------------
// ------------ PLAY BUTTON ---------
// ----------------------------------

// Get the play area element
const playArea = document.querySelector('area[alt="play"]');

music = new Audio(serverSounds + whatFolder + '/' + whatFile());
music.volume = 0.5;

// use for autoplay on maia start
const playMaia = function () {
    // tooltip mobile helper hide once click play
    document.querySelector('.play-button-tooltip-mobile').style.display = 'none';
    //display instructions on mobile by adding class visible
    //document.querySelector('.tooltip-mobile').classList.add('visible');

    // If the device is on
    if (powerStatut == true) {


        if (playStatut == false) {
            // if (music.paused) {

            music.play();
            //message
            messageInfo(messageInfo_fr.message4);
            playStatut = true;
            toggleShowNotes();
            // musicEnded();

        } else if (playStatut == true) {
            // } else if (!music.paused) {
            //message
            messageInfo(messageInfo_fr.message5);
            //pause music
            music.pause();
            // Change statut to "off"
            // TODO il existe music.paused pour savoir si music est en train de jouer
            playStatut = false;
            toggleShowNotes();
        }

    } else {
        if (powerStatut == false) {
            messageInfo(messageInfo_fr.message6);
        }
    }

};

// Attach a click event listener to the power area
playArea.addEventListener('click', (event) => {
    event.preventDefault();
    // tooltip mobile helper hide once click play
    document.querySelector('.play-button-tooltip-mobile').style.display = 'none';
    //display instructions on mobile by adding class visible
    //document.querySelector('.tooltip-mobile').classList.add('visible');
    // If the device is on
    if (powerStatut == true) {


        if (playStatut == false) {
            // if (music.paused) {

            music.play();
            //message
            messageInfo(messageInfo_fr.message4);
            playStatut = true;
            toggleShowNotes();
            // musicEnded();

        } else if (playStatut == true) {
            // } else if (!music.paused) {
            //message
            messageInfo(messageInfo_fr.message5);
            //pause music
            music.pause();
            // Change statut to "off"
            // TODO il existe music.paused pour savoir si music est en train de jouer
            playStatut = false;
            toggleShowNotes();
        }

    } else {
        if (powerStatut == false) {
            messageInfo(messageInfo_fr.message6);
        }
    }

});


// ----------------------------------
// ------------ PLUS BUTTON ---------
// ----------------------------------

// Get the plus button area element
const plusArea = document.querySelector('area[alt="volume up"]');


const buttonPlusMouseDown = (event) => {
    // tooltip mobile helper hide once click play
    document.querySelector('.play-button-tooltip-mobile').style.display = 'none';
    //display instructions on mobile by adding class visible
    //document.querySelector('.tooltip-mobile').classList.add('visible');
    let i = 0;
    if (i = 0) {

    };

    intervalID = setInterval(() => {
        i++;
        if (i > 0) {
            rowEtatPlusButton.style.display = "flex";
        };
        //Seconds before volume up Maia
        if (i >= 3) {
            clearInterval(intervalID);

            rowEtatPlusButton.children.compteur.innerHTML = i + 's';
            longPress = true;
            volumeUp(event);


        } else {
            rowEtatPlusButton.children.compteur.innerHTML = i + 's';

        }
    }, 1000);
};

const buttonPlusMouseUp = (event) => {
    clearInterval(intervalID);
    rowEtatPlusButton.children.compteur.innerHTML = '';
    rowEtatPlusButton.style.display = "none";
    if (longPress == false) {

        nextTrack(event)
    }
    //reset longPress
    longPress = false;
}


plusArea.addEventListener("mousedown", buttonPlusMouseDown);
plusArea.addEventListener("mouseup", buttonPlusMouseUp);
plusArea.addEventListener('mouseleave', () => {
    clearInterval(intervalID);
    compteur.innerHTML = '';
    // compteur.style.visibility ="hidden";
    rowEtatPlusButton.style.display = "none";
});



const volumeUp = () => {
    // volume max en 2e argument de la function Math.min
    if (powerStatut === true) {
        music.volume = Math.min(music.volume + 0.5, 1);
    }
    if (powerStatut === true && music.volume === 1) {
        messageInfo(messageInfo_fr.message7)
    }
    if (powerStatut === true && music.volume < 1) {
        messageInfo(messageInfo_fr.message8)
    }
}


const nextTrack = function (event) {
    // If the device is off text alert
    if (powerStatut == false) {
        messageInfo(messageInfo_fr.message9)
    }
    // If the device is On
    if (powerStatut == true) {
        // If a music is already played

        music.pause();
        music.currentTime = 0;

        // Change to next index then play the next file
        audioFileIndex++;

        if (audioFileIndex >= whatFolderLength()) {
            audioFileIndex = 0;
        }
        // music = new Audio(serverSounds + whatFolder + '/' + whatFile());
        music.src = serverSounds + whatFolder + '/' + whatFile();

        // music.load();
        // si deja en cours de lecture
        if (playStatut == true) {

            music.play();
        }
        // document.querySelector('.current-track').textContent = fileToPlay;
        //changement image
        imgTrackMaia.src = fileToPlayImage;

        animeIcons(event);
        // musicEnded();

        // Add a message
        messageInfo(messageInfo_fr.message1 + whatFile())
    }
}


// ----------------------------------
// --------- MINUS BUTTON -----------
// ----------------------------------

// Get the minus button area element
const minusArea = document.querySelector('area[alt="volume down"]');

const buttonMinusMouseDown = (event) => {
    // tooltip mobile helper hide once click play
    document.querySelector('.play-button-tooltip-mobile').style.display = 'none';
    //display instructions on mobile by adding class visible
    //document.querySelector('.tooltip-mobile').classList.add('visible');
    let i = 0;
    if (i = 0) {

    };

    intervalID = setInterval(() => {
        i++;
        if (i > 0) {
            rowEtatMinusButton.style.display = "flex";
        };
        //Seconds before volume down Maia
        if (i >= 3) {
            clearInterval(intervalID);

            rowEtatMinusButton.children.compteur.innerHTML = i + 's';
            longPress = true;
            volumeDown(event);


        } else {
            rowEtatMinusButton.children.compteur.innerHTML = i + 's';

        }
    }, 1000);
};

const buttonMinusMouseUp = (event) => {
    clearInterval(intervalID);
    rowEtatMinusButton.children.compteur.innerHTML = '';
    rowEtatMinusButton.style.display = "none";
    if (longPress == false) {
        previousTrack(event)
    }
    //reset longPress
    longPress = false;
}


minusArea.addEventListener("mousedown", buttonMinusMouseDown);
minusArea.addEventListener("mouseup", buttonMinusMouseUp);
minusArea.addEventListener('mouseleave', () => {
    clearInterval(intervalID);
    compteur.innerHTML = '';
    // compteur.style.visibility ="hidden";
    rowEtatMinusButton.style.display = "none";
});


const volumeDown = () => {
    // volume max en 2e argument de la function Math.max
    if (powerStatut === true) {
        music.volume = Math.max(music.volume - 0.5, 0.1);
    }

    if (powerStatut === true && music.volume === 0.1) {
        messageInfo(messageInfo_fr.message10)

    }
    if (powerStatut === true && music.volume > 0.1) {
        messageInfo(messageInfo_fr.message11)

    }
}

const previousTrack = function (event) {
    // If the device is off text alert
    if (powerStatut === false) {

        messageInfo(messageInfo_fr.message9)
    }
    // If the device is On
    if (powerStatut === true) {
        // If a music is already played

        music.pause();
        music.currentTime = 0;

        // Change to next index then play the next file
        audioFileIndex--;

        if (audioFileIndex < 0) {
            audioFileIndex = whatFolderLength() - 1;
        }
        // music = new Audio(serverSounds + whatFolder + '/' + whatFile());
        music.src = serverSounds + whatFolder + '/' + whatFile();

        // music.load();
        // si music deja en cours
        if (playStatut == true) {
            music.play();
        }

        // document.querySelector('.current-track').textContent = fileToPlay;
        //changement image
        imgTrackMaia.src = fileToPlayImage;
        animeIcons(event);
        // musicEnded();
        // Add a message
        messageInfo(messageInfo_fr.message12 + whatFile())
        // messageInfoInnerHtml('<div>Vous venez de passer à la piste précedente. Vous écoutez actuellement :<br> ' + whatFile()+'</div>')
    }

}

const animeIcons = function (e) {
    // if e.srcElement
    if (e.srcElement.alt == 'power' && powerStatut == true) {
        //anime
        document.querySelector(".icon-folder").classList.add('zoom-in-out-box');
        // Remove animation class after it's done
        setTimeout(function () {
            document.querySelector(".icon-folder").classList.remove('zoom-in-out-box');
        }, 1000);
    }
    if (e.srcElement.alt == 'volume up' || e.srcElement.alt == 'volume down' && powerStatut == true) {

        // //anime
        // document.querySelector(".filetype-mp3").classList.add('zoom-in-out-box');
        // // Remove animation class after it's done
        // setTimeout(function () {
        //     document.querySelector(".filetype-mp3").classList.remove('zoom-in-out-box');
        // }, 1000);

        //anime image
        // document.querySelector(".current-track-img").classList.add('zoom-in-out-box2');
        // // Remove animation class after it's done
        // setTimeout(function () {
        //     document.querySelector(".current-track-img").classList.remove('zoom-in-out-box2');
        // }, 1000);
    }

}


// ------------MessageInfo()----------------------
const item5 = document.getElementById('desc5');
const messageMaiaInfoContainer = document.querySelector('.message-maia-info');

const messageInfo = function (message, duration) {
    // Add a message
    //TODO fadein
    messageMaiaInfoContainer.textContent = message;
    messageMaiaInfoContainer.style.display = "block";
    if (duration > 0) {
        setTimeout(function () {
            //TODO fadeout
            messageMaiaInfoContainer.style.display = "none";
        }, duration);
    }
}

const messageInfoInnerHtml = function (message, duration) {
    // Add a message
    //TODO fadein
    messageMaiaInfoContainer.innerHTML = message;
    messageMaiaInfoContainer.style.display = "block";
    if (duration > 0) {
        setTimeout(function () {
            //TODO fadeout
            messageMaiaInfoContainer.style.display = "none";
        }, duration);
    }
}

// document ready
document.addEventListener("DOMContentLoaded", function () {
    buttonAreaPosition();
    document.querySelector('.maia-state-text').textContent = messageTooltips_fr.message1
    document.getElementById('desc1-1').textContent = messageTooltips_fr.desc1_1
    document.getElementById('desc1-2').textContent = messageTooltips_fr.desc1_2
    document.getElementById('desc2-1').textContent = messageTooltips_fr.desc2_1
    document.getElementById('desc2-2').textContent = messageTooltips_fr.desc2_2
    document.getElementById('desc3-1').textContent = messageTooltips_fr.desc3_1
    document.getElementById('desc3-2').textContent = messageTooltips_fr.desc3_2
    document.getElementById('desc4-1').textContent = messageTooltips_fr.desc4_1
    document.getElementById('desc5-1').textContent = messageTooltips_fr.desc5_1

});

music.addEventListener('ended', musicEnded);


if (window.matchMedia("(pointer: coarse)").matches) {
    // touchscreen
    powerMaia()
    document.querySelector('.info-panel-maia1').style.display = 'flex';
    document.querySelector('.tooltip-mobile').classList.add('visible');
    //hide 2nd function from maia button on touch screen
    document.querySelector('#desc1').style.opacity = '0';
    document.querySelector('#desc2').style.opacity = '0';
    document.querySelector('#desc3').style.opacity = '0';
    document.querySelector('#desc4').style.opacity = '0';
}

window.addEventListener('resize', function () {
    buttonAreaPosition();
});

//button position when maia image = 411px
const buttonAreaPosition = function () {
    var screenWidth = window.innerWidth;

    if (screenWidth <= 580) {
        powerArea.coords = '87,158,20';
        plusArea.coords = '86,201,19';
        minusArea.coords = '85,244,18';
        playArea.coords = '86,286,19';
    } else {
        powerArea.coords = '128,230,25';
        plusArea.coords = '126,294,25';
        minusArea.coords = '125,355,25';
        playArea.coords = '125,415,25';
    }
}